export function responseError(payload) {
  if (!payload) {
    return null;
  }

  let errorData = payload;

  if (payload.status && payload.data) {
    errorData = payload.data;
  } else if (payload.response?.data) {
    errorData = payload.response.data;
  }

  if (typeof errorData === "string") {
    return errorData;
  }

  if (!errorData) {
    return "Beklenmeyen bir hata oluştu.";
  }

  if (errorData.errors) {
    const firstError = Object.values(errorData.errors)[0];

    if (Array.isArray(firstError)) {
      return firstError[0];
    }

    return firstError;
  }

  if (errorData.message) {
    return errorData.message;
  }

  if (errorData.data) {
    return errorData.data;
  }

  const values = Object.values(errorData);

  if (values.length) {
    return Array.isArray(values[0]) ? values[0][0] : values[0];
  }

  return "Beklenmeyen bir hata oluştu.";
}